import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BadgeIcon from '@mui/icons-material/Badge';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GppGoodIcon from '@mui/icons-material/GppGood';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import {Typography} from '@mui/material';
import {useEffect} from 'react';
import {useQueryClient} from 'react-query';
import {useDispatch} from 'react-redux';
import CustomisedCardLine from '../../../../../components/card/cardLine';
import TextCard from '../../../../../components/card/TextCard';
import MailBox from '../../../../../components/icons/MailBox';
import Payment from '../../../../../components/icons/Payment';
import ElementTitle from '../../../../../components/title/elementTitle/elementTitle';
import {GUARANTOR_INFO} from '../../../../../config/cacheKey';
import {ILoans} from '../../../../../models/guarantor.model';
import {
    changeRouteType,
    getpervInnerState,
} from '../../../../../redux/handleBackBtn/handleBackBtnSlice';
import {setHeaderTitle} from '../../../../../redux/headerTitle/headerTitleSlice';
import {IInnerStateHomeMenu} from '../../IHomeMenu';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

export default function GurantorDetail({setState}: IInnerStateHomeMenu) {
    const randomKeyForDispatch = Math.random();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const guarantorInfo = queryClient.getQueryData(GUARANTOR_INFO) as ILoans;
    const msg = `تسهیلات '${guarantorInfo.fullName}'  `;
    const LoanInfo = [
        {
            title: (
                <>
                    <Payment
                        sx={{
                            marginLeft: '5px',
                            fontSize: '24px',
                            marginBottom: '5px',
                        }}
                    />
                    میزان تسهیلات (ریال)
                </>
            ),
            value: guarantorInfo.amount,
        },
        {
            title: (
                <>
                    <AccountBalanceIcon sx={{marginLeft: '5px'}} /> منبع تامین
                    مالی
                </>
            ),
            value: guarantorInfo.financialSupplierTitle,
        },
        {
            title: '',
            value: (
                <TextCard
                    title="شرایط تسهیلات"
                    description={[
                        {
                            firstColumnText: 'تعداد اقساط',
                            secondColumnText: `${guarantorInfo.installmentCount} ماه `,
                        },
                        {
                            firstColumnText: '  فاصله بین اقساط',
                            secondColumnText: `${guarantorInfo.stepSpaceByMonth} ماه `,
                        },
                        {
                            firstColumnText: 'زمان بازپرداخت',
                            secondColumnText: `${guarantorInfo.durationByMonth} ماه `,
                        },
                        {
                            firstColumnText: 'تاریخ درخواست',
                            secondColumnText: guarantorInfo.creationDatePersian,
                        },
                    ]}
                />
            ),
        },
        {
            value: (
                <TextCard
                    title="شرایط بازپرداخت"
                    description={[
                        {
                            firstColumnText: 'مبلغ هر قسط (ریال)',
                            secondColumnText: guarantorInfo.installmentAmount,
                        },
                        {
                            firstColumnText: 'نوع بازپرداخت',
                            secondColumnText: guarantorInfo.repaymentTypeTitle,
                        },
                    ]}
                />
            ),
        },
    ];
    const guarantorInfoCard = [
        {
            title: (
                <>
                    <PersonIcon sx={{marginLeft: '5px'}} />
                    نام و نام خانوادگی
                </>
            ),
            value: guarantorInfo?.guarantorInfo.fullName,
        },
        {
            title: (
                <>
                    <BadgeIcon sx={{marginLeft: '5px'}} />
                    کد ملی
                </>
            ),
            value: guarantorInfo?.guarantorInfo.nationalCode,
        },
        {
            title: (
                <>
                    <CalendarMonthIcon sx={{marginLeft: '5px'}} />
                    تاریخ تولد
                </>
            ),

            value: guarantorInfo?.guarantorInfo.birthDate,
        },
        {
            title: (
                <>
                    <PhoneIphoneIcon sx={{marginLeft: '5px'}} />
                    شماره موبایل
                </>
            ),

            value: guarantorInfo?.guarantorInfo.mobileNumber,
        },
        {
            title: (
                <>
                    <MailBox
                        sx={{
                            marginLeft: '5px',
                            fontSize: '20px',
                            marginBottom: '5px',
                        }}
                    />
                    کد پستی
                </>
            ),
            value: guarantorInfo?.guarantorInfo.postalCode,
        },
        {
            title: (
                <>
                    <GppGoodIcon sx={{marginLeft: '5px'}} />
                    نوع ضمانت
                </>
            ),

            value: guarantorInfo?.guarantorInfo.guaranteeTypeTitle,
        },
        {
            title: (
                <>
                    <AttachMoneyIcon sx={{marginLeft: '5px'}} /> میانگین درآمد
                    (ريال)
                </>
            ),

            value: guarantorInfo?.guarantorInfo.incomeAverage,
        },
    ];
    const handleFile = () => {
        setState!('guarantorFile');
    };
    useEffect(() => {
        dispatch(
            setHeaderTitle({
                color: 'var(--header-color)',
                header: msg,
                parentRoute: 'guarantors',
            })
        );
        dispatch(changeRouteType({routeType: 'child'}));
        dispatch(
            getpervInnerState({
                prevInnerState: `guarantors ${randomKeyForDispatch}`,
            })
        );
    }, []);
    return (
        <div className="p-5 overflow-y-auto" style={{height: '100svh'}}>
            <>
                <div style={{marginBottom: '10px'}}>
                    <ElementTitle title={'مشخصات تسهیلات'} />
                </div>
                <CustomisedCardLine itemList={LoanInfo} />
            </>
            <>
                <div style={{marginBottom: '10px'}}>
                    <ElementTitle title={'مشخصات ضامن'} />
                </div>
                <CustomisedCardLine itemList={guarantorInfoCard} />
            </>
            <Typography
                className="primaryColorLight-900 cursor-pointer"
                sx={{
                    color: '#BBA57A',
                    marginBottom: '120px',
                    marginTop: '30px',
                    fontWeight: 'bold',
                }}
                onClick={handleFile}
            >
                مشاهده مستندات ضامن
            </Typography>
        </div>
    );
}
